import React, { createContext, useReducer, useContext, useEffect } from 'react';

const FormContext = createContext();

const formReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_FORM_DATA':
      return { ...state, formData: { ...state.formData, ...action.payload } };
    // case 'NEXT_STEP':
    //   const storedFormData = localStorage.getItem('formData');
    //   const parsedFormData = JSON.parse(storedFormData);
    //   return { ...state, step: state.step + 1, formData: { ...state.formData, ...action.payload } };
    case 'NEXT_STEP':
    const storedFormData = localStorage.getItem('formData');

    const parsedFormData = storedFormData ? JSON.parse(storedFormData) : null;

    return {
      ...state,
      step: state.step + 1,
      formData: {
        ...state.formData,
        ...(parsedFormData ? parsedFormData.formData : {}),
        ...action.payload,
      },
    };
    case 'PREV_STEP':
      return { ...state, step: state.step - 1, formData: { ...state.formData, ...action.payload }  };
    default:
      return state;
  }
};

const FormProviderBuyer = ({ children }) => {
  const [state, dispatch] = useReducer(formReducer, {
    step: 1,
    formData: {},
  });

  useEffect(() => {
    // Save form data to local storage
    localStorage.setItem('formData', JSON.stringify(state.formData));
  }, [state.formData]);

  return (
    <FormContext.Provider value={{ state, dispatch }}>
      {children}
    </FormContext.Provider>
  );
};

const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};

export { FormProviderBuyer, useFormContext };